import { Popover, Stack } from "@mui/material";
import { useEffect, useState } from "react";

const WushPopover = ({ anchor, children, side = 'left', forceClose, ...props }) => {
  const [anchorEl, setAnchorEl] = useState();
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if(forceClose) setAnchorEl(null);
  }, [forceClose]);

  return (
    <>
      <div style={{ display: 'flex' }} onClick={handleClick}>
        {anchor}
      </div>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: side,
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: side,
        }}
        {...props}
      >
        <Stack height="100%" p={2} overflow="scroll">
          {children}
        </Stack>
      </Popover>
    </>
  );
};

export default WushPopover;